import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react';
import '../../../../scss/common/inputs.scss';
const Select = observer(({
  elements = [],
  title = '',
  description = null,
  required = false,
  onChangeSelect = null,
  disabled = false,
  defaultValue = null
}) => {
  const selectRef = useRef(null);
  let startingIndex = elements.findIndex(e => {
    return e.value === defaultValue;
  });
  if (startingIndex < 0) {
    startingIndex = 0;
  }
  const [index, setIndex] = useState(startingIndex);
  const [showOptions, setShowOptions] = useState(false);
  useEffect(() => {
    let newStartingIndex = elements.findIndex(e => {
      return e.value === defaultValue;
    });
    if (newStartingIndex < 0) {
      newStartingIndex = 0;
    }
    setIndex(newStartingIndex);
  }, [defaultValue, elements]);
  const onChange = newIndex => {
    setIndex(newIndex);
    if (onChangeSelect) {
      onChangeSelect(elements[newIndex].value);
    }
    setShowOptions(false);
  };

  // For click outside of select
  useEffect(() => {
    document.addEventListener('mousedown', event => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: `cms-input cms-select-container`
  }, /*#__PURE__*/React.createElement("div", {
    className: "cms-input-title cms-select-title-container"
  }, title, required ? '*' : ''), description ? /*#__PURE__*/React.createElement("div", {
    className: "cms-input-description cms-select-description"
  }, description) : null, /*#__PURE__*/React.createElement("div", {
    className: "cms-select-input-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: `cms-custom-select-container`,
    ref: selectRef
  }, /*#__PURE__*/React.createElement("div", {
    className: `cms-custom-select ${showOptions ? 'open' : 'closed'}`,
    onClick: () => setShowOptions(!showOptions)
  }, elements[index].label, /*#__PURE__*/React.createElement("span", {
    className: `icon small ${showOptions ? 'arrow-up' : 'arrow-down'}`
  })), showOptions ? /*#__PURE__*/React.createElement("ul", {
    className: `cms-custom-select-options`
  }, elements.map((element, elementIndex) => {
    return /*#__PURE__*/React.createElement("li", {
      key: elementIndex,
      className: `cms-custom-select-option`,
      onClick: e => {
        onChange(elementIndex);
      }
    }, element.label);
  })) : null)));
});
export default Select;